// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__36Cp1","options":"AnswerScale_options__2RyRO","selected":"AnswerScale_selected__2VnBG"};